import { render, staticRenderFns } from "./LabelWithEditIconAndContent.vue?vue&type=template&id=61ea6240&"
import script from "./LabelWithEditIconAndContent.vue?vue&type=script&lang=js&"
export * from "./LabelWithEditIconAndContent.vue?vue&type=script&lang=js&"
import style0 from "./LabelWithEditIconAndContent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports